module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"pending_reviews":"可写评论 {count}","written_reviews":"我的评论 {count}"}}')
  delete Component.options._Ctor
}
